




















import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import {GetTenantInfo} from '../../../api/realTime'
import myTable from '../../../components/table/my-table.vue'
import ECharts from 'vue-echarts'
import walden from '../../../components/charts/themes/walden.json'
@Component({
    components: {myTable,ECharts}
})
export default class extends AbpBase {
    @Prop({type:Object,default:{}}) data:any;
    @Watch('data')
    wD(){
        if(this.data){
            this.list = this.data.data
            this.renderEcharts(this.data.data)
        }
    }
    list = []
    created(){
        ECharts.registerTheme('ovilia-green', walden);
        if(this.data){
            this.list = this.data.data
            this.renderEcharts(this.data.data)
        }
    }
    detail(row:any){
        this.$emit('detail',row)
    }
    columns = [
        {
            title: '时间',
            key: 'date',
            width:150,
            render:(h:any,p:any)=> {
                return h('div',[
                    h('span',p.row.date),
                    h('span',{
                        style:{
                            color:'rgb(64, 158, 255)',
                            marginLeft:'40px',
                            cursor: 'pointer',
                        },
                        on:{
                            'click':()=>{
                                this.detail(p.row)
                            }
                        }
                    },'详情')
                ])
            },
        },
        {
            title: '总数',
            key: 'allCount'
        },
        {
            title: '达标数（例）',
            key: 'standardsCount'
        },
        {
            title: '不达标数（例）',
            key: 'notStandardsCount'
        },
        {
            title: '超标数（例）',
            key: 'exceededCount'
        },
        {
            title: '达标率（%）',
            key: 'rate'
        },
        {
            title: '平均值',
            key: 'avg'
        },
        {
            title: '标准差',
            key: 'sd'
        },
        {
            title: '中位数',
            key: 'median'
        },
    ]
    renderEcharts(data:any){
        this.option1 = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {            
                    type: 'shadow'        
                }
            },
            title: {
                text: '月达标率统计',
                padding: 16,
                textStyle: {
                    fontSize: 16,
                    fontFamily: 'MicrosoftYaHei',
                    fontWeight: 'normal'
                }
            },
            legend:{
                data: ['达标', '不达标', '超标', '达标率'],
            },
            grid: {
                left: '3%',
                right: '3%',
                bottom: '5%',
                top: '20%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data: data.map((v:any)=>{return v.date}),
                    axisTick: {
                        alignWithLabel: true
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    name: '数量（例）',
                },
                {
                    type: 'value',
                    name: '达标率',
                    axisLabel: {
                        show: true,
                        formatter: "{value} %", //右侧Y轴文字显示
                    }
                }
            ],
            series: [
                {
                    name: '达标',
                    type: 'bar',
                    label: {
                        normal: {
                            show: true,
                            position: 'top',
                            color: '#999999',
                        }
                    },
                    data: data.map((v:any)=>{return v.standardsCount}),
                },
                {
                    name: '不达标',
                    type: 'bar',
                    label: {
                        normal: {
                            show: true,
                            position: 'top',
                            color: '#999999',
                        }
                    },
                    data: data.map((v:any)=>{return v.notStandardsCount}),
                },
                {
                    name: '超标',
                    type: 'bar',
                    label: {
                        normal: {
                            show: true,
                            position: 'top',
                            color: '#999999',
                        }
                    },
                    data: data.map((v:any)=>{return v.exceededCount}),
                },
                {
                    name: '达标率',
                    type: 'line',
                    yAxisIndex: 1,
                    data: data.map((v:any)=>{return v.rate}),
                }
            ]
        }
        this.option2 = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {            
                    type: 'shadow'        
                }
            },
            title: {
                text: '平均值',
                padding: 16,
                textStyle: {
                    fontSize: 16,
                    fontFamily: 'MicrosoftYaHei',
                    fontWeight: 'normal'
                }
            },
            legend:{
                data: ['平均值'],
            },
            grid: {
                left: '3%',
                right: '3%',
                bottom: '5%',
                top: '20%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data: data.map((v:any)=>{return v.date}),
                    axisTick: {
                        alignWithLabel: true
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    name: '平均值',
                    axisLabel: {
                        show: true,
                        formatter: "{value} g/L", //右侧Y轴文字显示
                    }
                }
            ],
            series: [
                {
                    name: '平均值',
                    type: 'line',
                    label: {
                        normal: {
                            show: true,
                            position: 'top',
                            color: '#999999',
                        }
                    },
                    data: data.map((v:any)=>{return v.avg}),
                },
            ]
        }
        this.option3 = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {            
                    type: 'shadow'        
                }
            },
            title: {
                text: '标准差',
                padding: 16,
                textStyle: {
                    fontSize: 16,
                    fontFamily: 'MicrosoftYaHei',
                    fontWeight: 'normal'
                }
            },
            legend:{
                data: ['标准差'],
            },
            grid: {
                left: '3%',
                right: '3%',
                bottom: '5%',
                top: '20%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data: data.map((v:any)=>{return v.date}),
                    axisTick: {
                        alignWithLabel: true
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    name: '标准差',
                    axisLabel: {
                        show: true,
                        formatter: "{value}", //右侧Y轴文字显示
                    }
                }
            ],
            series: [
                {
                    name: '标准差',
                    type: 'line',
                    label: {
                        normal: {
                            show: true,
                            position: 'top',
                            color: '#999999',
                        }
                    },
                    data: data.map((v:any)=>{return v.sd}),
                },
            ]
        }
        this.option4 = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {            
                    type: 'shadow'        
                }
            },
            title: {
                text: '中位数',
                padding: 16,
                textStyle: {
                    fontSize: 16,
                    fontFamily: 'MicrosoftYaHei',
                    fontWeight: 'normal'
                }
            },
            legend:{
                data: ['中位数'],
            },
            grid: {
                left: '3%',
                right: '3%',
                bottom: '5%',
                top: '20%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data: data.map((v:any)=>{return v.date}),
                    axisTick: {
                        alignWithLabel: true
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    name: '中位数',
                    axisLabel: {
                        show: true,
                        formatter: "{value}", //右侧Y轴文字显示
                    }
                }
            ],
            series: [
                {
                    name: '中位数',
                    type: 'line',
                    label: {
                        normal: {
                            show: true,
                            position: 'top',
                            color: '#999999',
                        }
                    },
                    data: data.map((v:any)=>{return v.median}),
                },
            ]
        }
        this.option5 = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {            
                    type: 'shadow'        
                }
            },
            title: {
                text: '年累计达标率统计',
                padding: 16,
                textStyle: {
                    fontSize: 16,
                    fontFamily: 'MicrosoftYaHei',
                    fontWeight: 'normal'
                }
            },
            legend:{
                data: ['达标','不达标','超标'],
            },
            series : [
                {
                    name: '达标',
                    type: 'pie',
                    radius : '55%',
                    center: ['50%', '50%'],
                    label: {
                        normal: {
                            formatter: '{b}：{c}({d}%)',
                        }
                    },
                    data:[
                        {
                            name:'达标',
                            value:(data.map((v:any)=>{return v.standardsCount})).reduce((prev,item)=>{
                                return prev += item;
                            }),

                        },
                        {
                            name:'不达标',
                            value:(data.map((v:any)=>{return v.notStandardsCount})).reduce((prev,item)=>{
                                return prev += item;
                            })
                        },
                        {
                            name:'超标',
                            value:(data.map((v:any)=>{return v.exceededCount})).reduce((prev,item)=>{
                                return prev += item;
                            })
                        },
                    ]
                },
            ]
        }
    }
    option1:any = {}
    option2:any = {}
    option3:any = {}
    option4:any = {}
    option5:any = {}
    downxlsx(){
        let XLSX = this.$XLSX;
        var xlsxParam = { raw: true };//转换成excel时，使用原始的格式
        var wb = XLSX.utils.table_to_book(document.querySelector("#mytable"),xlsxParam);//mytable为表格的id名
        var wbout = XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: true,
            type: "array"
        });
        try {
            this.$FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            this.$route.meta.title+".xlsx"
            );
        } catch (e) {
            if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
    }
}
